(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lumaaura-delivery-estimate"] && !Shopify.designMode) return;
  try {
    function initializeLumaAuraDeliveryEstimates(root = document) {
    root.querySelectorAll('.lumaaura-delivery-estimate').forEach((component) => {
      const output = component.querySelector('[data-lumaaura-delivery-date]');
      if (!output) return;

      const startDays = Number(component.dataset.deliveryStart || 7);
      const endDays = Number(component.dataset.deliveryEnd || 12);
      const startDate = new Date();
      const endDate = new Date();
      startDate.setDate(startDate.getDate() + startDays);
      endDate.setDate(endDate.getDate() + endDays);

      const locale = document.documentElement.lang || 'en-US';
      const formatter = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
      output.textContent = `${formatter.format(startDate)} - ${formatter.format(endDate)}`;
    });
  }

  initializeLumaAuraDeliveryEstimates();
  document.addEventListener('shopify:section:load', (event) => initializeLumaAuraDeliveryEstimates(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lumaaura-product-support"] && !Shopify.designMode) return;
  try {
    function initializeLumaAuraDelivery(root = document) {
    root.querySelectorAll('.lumaaura-product-support').forEach((component) => {
      const output = component.querySelector('[data-delivery-date]');
      if (!output) return;

      const startDays = Number(component.dataset.deliveryStart || 7);
      const endDays = Number(component.dataset.deliveryEnd || 12);
      const startDate = new Date();
      const endDate = new Date();
      startDate.setDate(startDate.getDate() + startDays);
      endDate.setDate(endDate.getDate() + endDays);

      const formatter = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
      output.textContent = `${formatter.format(startDate)} - ${formatter.format(endDate)}`;
    });
  }

  initializeLumaAuraDelivery();
  document.addEventListener('shopify:section:load', (event) => initializeLumaAuraDelivery(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lumaaura-shoppable-video"] && !Shopify.designMode) return;
  try {
    function initializeLumaAuraShoppableVideos(root = document) {
    root.querySelectorAll('.lumaaura-shoppable-video').forEach((component) => {
      if (component.dataset.lumaauraNavigationInitialized === 'true') return;
      component.dataset.lumaauraNavigationInitialized = 'true';

      const track = component.querySelector('.lumaaura-shoppable-video__track');
      component.querySelectorAll('[data-lumaaura-video-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = Number(button.dataset.lumaauraVideoScroll);
          track?.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
        });
      });
    });

    root.querySelectorAll('[data-lumaaura-video-open]').forEach((button) => {
      if (button.dataset.lumaauraInitialized === 'true') return;
      button.dataset.lumaauraInitialized = 'true';
      button.addEventListener('click', () => document.getElementById(button.dataset.lumaauraVideoOpen)?.showModal());
    });

    root.querySelectorAll('[data-lumaaura-video-dialog]').forEach((dialog) => {
      if (dialog.dataset.lumaauraInitialized === 'true') return;
      dialog.dataset.lumaauraInitialized = 'true';

      const close = () => {
        dialog.querySelectorAll('video').forEach((video) => video.pause());
        dialog.close();
      };

      dialog.querySelector('[data-lumaaura-video-close]')?.addEventListener('click', close);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
      dialog.addEventListener('close', () => dialog.querySelectorAll('video').forEach((video) => video.pause()));
    });
  }

  initializeLumaAuraShoppableVideos();
  document.addEventListener('shopify:section:load', (event) => initializeLumaAuraShoppableVideos(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lumaaura-size-chart"] && !Shopify.designMode) return;
  try {
    function initializeLumaAuraSizeCharts(root = document) {
    root.querySelectorAll('.lumaaura-size-chart').forEach((component) => {
      if (component.dataset.initialized === 'true') return;
      component.dataset.initialized = 'true';

      const dialog = component.querySelector('[data-size-chart-dialog]');
      const openButton = component.querySelector('[data-size-chart-open]');
      const closeButton = component.querySelector('[data-size-chart-close]');
      if (!dialog || !openButton || !closeButton) return;

      openButton.addEventListener('click', () => dialog.showModal());
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  initializeLumaAuraSizeCharts();
  document.addEventListener('shopify:section:load', (event) => initializeLumaAuraSizeCharts(event.target));
  } catch(e) { console.error(e); }
})();

})();
